import 'css-chunk:src/components/tooltip/tooltip-component.module.scss';export default {
  "tooltip-elt-container": "tooltip-component_tooltip-elt-container__2LIzf",
  "tooltip-component": "tooltip-component_tooltip-component__Jj9vl"
};